import {Locales} from '@netx/core-next/locales/utils/Locales';
import {NetxThemeMode} from './constants';

export const NetxThemeTitle = Locales((i18n) => ({
	THEME: i18n('i18n.theme'),
}));

export const NetxThemeModeLabel = Locales((i18n) => ({
	[NetxThemeMode.DEFAULT]: i18n('i18n.themeModeDefault'),
	[NetxThemeMode.DARK]: i18n('i18n.themeModeDark'),
	[NetxThemeMode.LIGHT]: i18n('i18n.themeModeLight'),
}));
